import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'STATUS_DOC',
  title: 'A cosa corrisponde lo status di un documento?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Ogni titolo di documento è seguito da un pittogramma che vi permetterà di conoscere il suo stato:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Mancante: il documento non è mai stato depositato'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'In attesa di firma: il documento deve essere firmato dal firmatario del conto'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Rifiutato: il documento è stato rifiutato, consultare il motivo del rifiuto'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Scaduto: il documento ha una data di scadenza scaduta'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'In attesa di raccolta: il documento è in fase di raccolta da parte dei nostri servizi'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'In attesa di verifica: tutti i documenti depositati sono verificati e autenticati dai servizi di OnceForAll'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Valido: Il documento è disponibile per i vostri clienti'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_STATUT_DOC/IT_STATUT_DOC_6.png`
  }]
};
